/* eslint-disable */

import { ref, onUnmounted, onMounted, watch, reactive } from "vue";
import { useRouter } from 'vue-router';


type imgName = {
  data: string[];
};

const url = "https://static.web.sdo.com/mxd/pic/wiki/";



export default function usePopupImg() {

  let imgName: imgName = reactive({ data: [] });
  let title = ref("");
  let show = ref(false);
  let pos = reactive({ x: 0, y: 0 });
  let className = reactive({ data: [''] })
  let type = ref(0); //gif或是img
  const showSpin = ref(false);

  // watch(
  //   () => {
  //     return imgName.data;
  //   },
  //   (state, preState) => {
  //     if (state.length === 0) {

  //       imgName.data = [];
  //       return false;
  //     }

  //   }
  // );

  onMounted(() => {
    var testUl = document.getElementById("layout-article");


    testUl!.addEventListener("click", function (event) {

      var ev = event || window.event;
      let target = ev.target as HTMLInputElement;
      // return
      let imgNames = target!.getAttribute("data-popup-img") as string || target!.getAttribute("data-popup-gif") as string;

      if (!imgNames) {
        show.value = false;
        return
      }
      showSpin.value = true

      let ch = document.documentElement.clientHeight;
      let cw = document.documentElement.clientWidth;
      let maxH = 0;



      if (target!.getAttribute("data-popup-img") as string) {
        type.value = 0
        className.data = []
      }
      else if (target!.getAttribute("data-popup-gif") as string) {
        type.value = 1;
        className.data = ['gif-style']
      } else {
        imgName.data = [];
        return;
      }




      imgName.data = imgNames.split(",");
      for (const index in imgName.data) {
        let image = new Image();
        image.src = imgName.data[index] = url + imgName.data[index];
        image.onload = function () {

          if (type.value == 0) {

            pos.x = ev.pageX;
            pos.y = ev.clientY;
            image.height > maxH && (maxH = image.height);
            // console.log(maxH, pos.y, ch);

            if (maxH + pos.y > ch) {
              pos.y = ch - maxH;
            }
          } else if (type.value == 1) {
            pos.x = cw / 2 - image.width / 2;
            pos.y = ch / 2 - image.height / 2
          }
          showSpin.value = false

          show.value = true;
        };
      }

    });
  });

  const router = useRouter();

  router.afterEach(() => {
    pos.x = 100000
  });

  return { imgName, title, show, pos, className, type, showSpin };
}
